import React from "react";
import PropTypes from "prop-types";

import { Icon, Modal, useHeaderStyles } from "..";

export function FormModalHeader({
  clientName,
  workflowName,
  taskTitle,
  formName,
  onClose,
}) {
  const headerClasses = useHeaderStyles();
  return (
    <Modal.Header className={headerClasses.header}>
      <div style={{ display: "flex" }}>
        <div style={{ flexGrow: 1 }}>
          <div style={{ lineHeight: "20px" }}>
            <div
              style={{ color: "#AAAAAA", fontSize: "14px", fontWeight: "bold" }}
            >
              {clientName}
            </div>
            <div style={{ fontSize: "14px", fontWeight: "normal" }}>
              {workflowName}
              {formName ? `: ${taskTitle}` : ""}
            </div>

            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
              {formName || taskTitle}
            </div>
          </div>
        </div>
        <Icon name="close" onClick={onClose} data-test="modal-close-button" />
      </div>
    </Modal.Header>
  );
}

FormModalHeader.propTypes = {
  clientName: PropTypes.string,
  workflowName: PropTypes.string,
  taskTitle: PropTypes.string,
  formName: PropTypes.string,
  onClose: PropTypes.func,
};

FormModalHeader.defaultProps = {
  clientName: "",
  workflowName: "",
  taskTitle: "",
  formName: "",
  onClose: () => {},
};

export default FormModalHeader;
